export default {
  title: "Výběr posilovny",
};
